/* SanitairLuxe — "Maak je toilet compleet" (snippet sl-toilet-compleet) */
(() => {
  if (window.slToiletCompleet) return;
  window.slToiletCompleet = true;

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
    } catch (e) {
      return '€ ' + ((cents || 0) / 100).toFixed(2).replace('.', ',');
    }
  };

  const parseMap = (str) => {
    const map = {};
    (str || '').split('|').forEach((pair) => {
      const i = pair.indexOf(':');
      if (i > 0) map[pair.slice(0, i).trim().toLowerCase()] = pair.slice(i + 1).trim().toLowerCase();
    });
    return map;
  };

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    let toiletVariants = [];
    try {
      toiletVariants = JSON.parse(root.querySelector('[data-toilet-variants]').textContent);
    } catch (e) {}
    let variantId = parseInt(root.dataset.variantId, 10);
    const rows = Array.from(root.querySelectorAll('[data-row]'));
    const totalEl = root.querySelector('[data-total]');
    const addBtn = root.querySelector('[data-add]');
    const msg = root.querySelector('[data-msg]');

    const currentToilet = () => toiletVariants.find((v) => v.id === variantId) || null;

    const rowOption = (row) => {
      const sel = row.querySelector('[data-select]');
      return sel ? sel.options[sel.selectedIndex] : null;
    };

    const paintRow = (row) => {
      const opt = rowOption(row);
      const priceEl = row.querySelector('[data-price-label]');
      const img = row.querySelector('[data-img]');
      if (!opt) return;
      if (priceEl) priceEl.textContent = '+ ' + money(parseInt(opt.dataset.price, 10));
      if (img && opt.dataset.img) img.src = opt.dataset.img;
    };

    /* Woorden die iets over de kleur zeggen (geen merk- of vulwoorden) */
    const STOP = new Set(['default', 'title', 'met', 'van', 'voor', 'zonder', 'wc', 'toilet', 'hangtoilet', 'wandcloset', 'rimless', 'randloos', 'zitting', 'bril', 'toiletbril', 'softclose', 'soft', 'close', 'quick', 'release', 'model', 'duroplast', 'rvs', 'inox', 'scharnieren', 'bidet', 'cm']);
    const words = (text) => String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .split(/[^a-z]+/).filter((w) => w.length >= 3 && !STOP.has(w));
    const bestByWords = (sel, colourText) => {
      const want = words(colourText);
      if (!want.length) return null;
      let best = null;
      let bestScore = 0;
      Array.from(sel.options).forEach((o) => {
        const have = new Set(words(o.dataset.title || o.textContent));
        const score = want.filter((w) => have.has(w)).length;
        if (score > bestScore) { best = o; bestScore = score; }
      });
      return best;
    };

    const applyColour = () => {
      const toilet = currentToilet();
      if (!toilet) return;
      const colour = String(toilet.title).toLowerCase();
      rows.forEach((row) => {
        if (row.dataset.touched) return;
        const sel = row.querySelector('[data-select]');
        if (sel) {
          const want = parseMap(row.dataset.map)[colour];
          let match = want ? Array.from(sel.options).find((o) => (o.dataset.title || '').toLowerCase() === want) : null;
          if (!match && !row.dataset.map) match = bestByWords(sel, toilet.colour || toilet.title);
          if (match) sel.value = match.value;
        }
        paintRow(row);
      });
    };

    const updateTotal = () => {
      const toilet = currentToilet();
      let total = toilet ? toilet.price : 0;
      rows.forEach((row) => {
        const check = row.querySelector('[data-check]');
        const opt = rowOption(row);
        row.classList.toggle('is-checked', !!(check && check.checked));
        if (check && check.checked && opt) total += parseInt(opt.dataset.price, 10) || 0;
      });
      if (totalEl) totalEl.textContent = money(total);
      if (addBtn) addBtn.disabled = !(toilet && toilet.available);
    };

    rows.forEach((row) => {
      const sel = row.querySelector('[data-select]');
      const check = row.querySelector('[data-check]');
      if (sel) {
        sel.addEventListener('change', () => {
          row.dataset.touched = '1';
          if (check) check.checked = true;
          paintRow(row);
          updateTotal();
        });
      }
      if (check) check.addEventListener('change', updateTotal);
    });

    document.addEventListener('product:variant-change', (event) => {
      const v = event.detail && event.detail.variant;
      if (!v || !toiletVariants.some((t) => t.id === v.id)) return;
      variantId = v.id;
      applyColour();
      updateTotal();
    });

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = [{ id: variantId, quantity: 1 }];
        rows.forEach((row) => {
          const check = row.querySelector('[data-check]');
          const opt = rowOption(row);
          if (check && check.checked && opt) items.push({ id: parseInt(opt.value, 10), quantity: 1 });
        });
        const label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Bezig met toevoegen...';
        if (msg) { msg.textContent = ''; msg.className = 'sl-tc__msg'; }
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Toevoegen mislukt');
          const cart = await (await fetch('/cart.js')).json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .sl-cart-count').forEach((el) => {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          const added = (data.items || []).find((i) => i.variant_id === variantId) || (data.items || [])[0];
          if (window.SLCartModal && added) {
            window.SLCartModal.show(added);
          } else if (msg) {
            msg.textContent = 'Toegevoegd aan je winkelwagen.';
            msg.className = 'sl-tc__msg is-ok';
          }
        } catch (e) {
          if (msg) {
            msg.textContent = e.message || 'Toevoegen mislukt. Probeer het opnieuw.';
            msg.className = 'sl-tc__msg is-error';
          }
        } finally {
          addBtn.textContent = label;
          updateTotal();
        }
      });
    }

    applyColour();
    updateTotal();
  }

  /* "Vaak samen gekocht" opnieuw laden voor de gekozen toiletkleur */
  let csController;
  let csGen = 0;
  document.addEventListener('product:variant-change', async (event) => {
    const v = event.detail && event.detail.variant;
    if (!v || !document.querySelector('[data-sl-toilet-compleet]')) return;
    const panel = document.querySelector('.sl-cross-sell[data-section-id]');
    if (!panel || panel.hasAttribute('data-sl-dutchline-crosssell')) return;
    const sectionId = panel.dataset.sectionId;
    const wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!wrapper) return;
    if (csController) csController.abort();
    csController = new AbortController();
    const gen = ++csGen;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    url.searchParams.set('section_id', sectionId);
    try {
      const res = await fetch(url, { signal: csController.signal });
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.getElementById(wrapper.id);
      if (gen !== csGen || !fresh) return;
      wrapper.innerHTML = fresh.innerHTML;
    } catch (e) {}
  });

  const boot = () => document.querySelectorAll('[data-sl-toilet-compleet]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
